<template>
  <div>
    <span v-if="!formVisible" class="username">
      <span v-if="currentUser.isDeleted" class="deleted">{{
        currentUser.name
      }}</span>
      <a v-else-if="canUpdateUsers" :href="'/users/' + currentUser.slug">{{
        currentUser.name
      }}</a>
      <span v-else>{{ currentUser.name }}</span>
      <small class="edit-link">
        <a @click.prevent="formVisible = true">{{ label }}</a>
      </small>
    </span>
    <form v-else>
      <div class="form-group">
        <search-field
          :initial-id="currentUser.id"
          :initial-value="currentUser.name"
          value-property="name"
          src="/users/typeahead?name="
          :searching-label="searchingLabel"
          @selected="select"
          @error="handleErrors"
        />
      </div>
      <div class="form-group">
        <button
          :class="['btn', 'btn-primary', 'btn-sm', { disabled: saving }]"
          type="submit"
          @click.prevent="submit"
        >
          {{ saveButtonLabel }}
        </button>
        <button
          class="btn btn-secondary btn-sm"
          @click.prevent="formVisible = false"
        >
          {{ cancelButtonLabel }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { SearchField } from 'vue-bootstrap';
import toastr from 'toastr';

export default {
  components: {
    SearchField
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    canUpdateUsers: {
      type: Boolean,
      default: false
    },
    entrySlug: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Edit user'
    },
    searchingLabel: {
      type: String,
      default: 'Searching...'
    },
    saveButtonLabel: {
      type: String,
      default: 'Save'
    },
    cancelButtonLabel: {
      type: String,
      default: 'Cancel'
    }
  },
  data() {
    return {
      formVisible: false,
      currentUser: null,
      selectedUser: null,
      saving: false
    };
  },
  created() {
    this.currentUser = this.user;
  },
  methods: {
    select(user) {
      this.selectedUser = user;
    },
    handleErrors(error) {
      toastr.error(
        error.response.data.message ||
          document.getElementById('alerts-generic').innerHTML
      );

      this.saving = false;
    },
    submit() {
      if (this.saving) return;

      if (!this.selectedUser) {
        this.formVisible = false;
        return;
      }

      const url = `/entry-form/manager/update-owner/${this.entrySlug}/${this.selectedUser.slug}`;

      this.saving = true;

      this.$http.post(url).then(
        () => {
          this.currentUser = this.selectedUser;
          this.formVisible = false;

          this.saving = false;
        },
        error => {
          this.handleErrors(error);
        }
      );
    }
  }
};
</script>

<style scoped>
.edit-link {
  display: none;
}

.username:hover .edit-link {
  line-height: 19px;
  display: inline;
}
</style>
